<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model="dataModel"
          :options="options"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          @onDataChange = 'DataOnChange'
          @changeTitle="changeTitle"
        ></BaseDatatable>
        <Dialog
          style=""
          header="Delete"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Do you want to delete <strong>{{this.deleteName}}</strong>
          <template
            #footer
          >
            <Button label="Yes" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
            <Button
              label="Cancel"
              @click="showDeleteDialog = false"
              icon="pi pi-times"
              class="p-button-warning"
            />
          </template>
        </Dialog>
        <Dialog
          header="Change member’s role"
          :visible.sync="showExchangeDialog"
          :containerStyle="{width: '35vw'}"
          class="change_member__role"
          :modal="true"
        >
          <template #header>
            <div>
              <h4>Change member’s role</h4>
              <small>Select and change user permissions in the club</small>
            </div>
          </template>
          <div class="field-radiobutton d-flex align-items-center p-3" v-for="(item,index) in roleArr" :key="index">
            <RadioButton :id="item.value" name="role" :value="item.value" v-model="exchangeValue" />
            <label class="mb-0 ml-2 w-100" :for="item.value">{{item.label}}</label>
          </div>
          <template
            #footer
          >
            <Button
              label="Cancel"
              @click="showExchangeDialog = false"
              class="p-button-warning"
            />
            <Button label="Save" @click="exchangeData()" class="p-button-danger" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseDatatable from './list'
export default {
  components: {
    BaseDatatable,
  },
  data() {
    return {
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      page_transaction:null,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      dataDelete :{},
      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      exchangeId: null,
      exchangeValue: null,
      exchangeUid: null,
      showExchangeDialog: false,
      roleArr: [{
          value: 'member',
          label: 'Member'
      },
      {
          value: 'admin',
          label: 'Admin'
      },
      {
          value: 'owner',
          label: 'Owner'
      }]
    }
  },
  mounted () {
    this.initParams();
  },
  async created() {
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    //console.log('this.dataModel:',this.dataModel);
    this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
      window.location.reload();
    }
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_CLUB);
    if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0){
      this.$router.push({path: this.$constants.URL_ERR.FOBIDDEN});
    }
    this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false:true;
    this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false:true;
    this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false:true;
  },
  watch: {
    '$route': 'initParams'
  },
  methods: {
    changeTitle(data) {
      this.title = this.dataModel.label;
      if (data && data != undefined)  this.title = this.title + ' - ' + data;
    },
    initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.title = this.dataModel.label;
      this.callbackOptions();
    },
    onChange() {
      this.$store.commit('setLoading', true);
      // this.$apollo.queries.listData.refresh()
    },
    DataOnChange(data,f){
      if(f.type == 'Checkbox'){
        let dataUpdate = {}
        if(f.key == 'active'){
          dataUpdate['active'] = data[f.key]
        }
        let variables = {
          'data_update': dataUpdate,
          'where_key': {
            'id': {'_eq': data.id}
          }
        };
        this.$apollo.mutate({
          mutation: DataServices.updateData(this.modelName),
          variables: variables
        }).then(() => {})
      }
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      // console.log("field",field)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      // console.log("result",result)
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      // if (this.role.add) {
      //   actions.header = {name: 'add', icon: 'plus', path: `list-${this.modelName}/add`};
      // }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        if (that.role.edit) {
          buttons.edit = {name: 'edit', icon: 'pencil', key: 'uid', path: `/admin/list-users/edit/`};
        }
        if (that.role.delete) {
          buttons.delete = {name: 'delete', icon: 'trash', key: 'id'};
        }
        buttons.exchange = {name: 'exchange', key: 'id'};
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async callbackOptions() {
      var fields = this.dataModel.getDisplayFields();
      var attributes = [];
      for (let index = 0; index < fields.length; index++) {
        const element = fields[index];
        if (element.models !== undefined && element.models !== null) {
          // console.log("SDFGHJK",element)
          var optionsData = [];
          attributes.push(element.models.key.key);
          attributes.push(element.models.display_key);
          var where_ = {}
        if( element['name']== "skill_id"){
            // console.log("element",element)
            let {data} = await this.$apollo.query({
              query: DataServices.getList("skill", {"fields" : "id skill_lang{lang name}"}),
              variables: {
                where_key : {
                  deleted : {_eq: false}
                },
                orderBy:[{ordinal: 'desc'},{created_at : 'desc'}]
              }
            })
            if (data) {
              var ress = data[Object.keys(data)];
              // console.log("+=============",ress)
              if (ress) {
                for (let index = 0; index < ress.length; index++) {
                  const ele = ress[index];
                  var skill_name = ''
                  if(ele.skill_lang){
                    for (let j = 0; j < ele.skill_lang.length; j++) {
                      if(ele.skill_lang[j].lang == 'en'){
                        skill_name = ele.skill_lang[j].name;
                        break;
                      }
                    }
                  }
                  if(skill_name !== ''){
                    optionsData.push({value: ele.id, label: skill_name})
                  }
                }
              }
            }
          }else{
            var {data} = await this.$apollo.query({
              query: DataServices.getList(element.models.tableName, {"fields" : attributes.join(',')}),
              variables: {where_key : where_}
            })
            if (data) {
              var result = data[Object.keys(data)];
              if (result) {
                for (let index = 0; index < result.length; index++) {
                  const ele = result[index];
                  optionsData.push({value: ele[attributes[0]], label: ele[attributes[1]]})
                }
              }
            }
          }
          console.log("optionsData",optionsData)
          this.options[element.key] = optionsData;
        }
        this.componentKey++;
      }

    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString() }  })
          } else  {
            this.page_transaction = pageTransaction.toString();
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.dataDelete = data.data
          this.showDeleteDialog = true
          break
        case 'exchange':
          this.exchangeId = data.data[action.key]
          this.exchangeValue = data.data.role
          this.exchangeUid = data.data.uid
          this.showExchangeDialog = true
          break
        // case 'add':
        //   this.dialogMode = action.name
        //   if (action.path !== undefined && action.path) {
        //     this.$router.push({ path: action.path })
        //   } else  {
        //     this.displayDialog = true
        //     this.editDialogKey++
        //   }
        //   break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    async sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    async checkRoleBeforeExchange() {
      var {data} = await this.$apollo.query({
        query: DataServices.getList('clubs_member', {"fields" : "id"}),
        variables: {
          where_key: {
            role: {_eq: "owner"},
            uid: {_eq: this.exchangeUid}
          }
        },
        fetchPolicy: "network-only"
      })
      return data && data[Object.keys(data)].length > 0;
    },
    async exchangeData() {
      // if (this.checkRoleBeforeExchange() && this.exchangeValue == 'owner') {
      //   this.$toast.add({ severity: 'error', summary: 'Failed', detail: "This user is already the owner of another club ", life: 3000 })
      //   return;
      // }
      this.showExchangeDialog = false;
      var query = DataServices.updateData('clubs_member')
      var variables = {
        'data_update': {
          'role': this.exchangeValue
        },
        where_key: {
          id: {'_eq': this.exchangeId}
        }
      }
      await this.$apollo.mutate({
        mutation: query,
        variables: variables
      }).then(async (res) => {
        if (this.exchangeValue == 'owner') {
          var query_ = DataServices.updateData('clubs_member')
          var variables_ = {
            'data_update': {
              'role': 'member'
            },
            where_key: {
              role: {'_eq': 'owner'},
              clubs_id: {'_eq': this.$route.params.id},
              id: {'_neq': this.exchangeId}
            }
          }
          await this.$apollo.mutate({
            mutation: query_,
            variables: variables_
          })
        }
        // console.log("res.data.",res.data)
        if (res.data.update_clubs_member.affected_rows > 0) {
          this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Update role success', life: 3000 })
          this.componentKey++
          // window.location.reload()
        } else this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Update role failed', life: 3000 })
        // this.$apollo.queries.listData.refresh()
      })
    },
    async deleteData() {
      this.showDeleteDialog = false
      var query = DataServices.deleteData('clubs_member')
      var variables = {
        where_key: {
          id: {'_eq': this.deleteId}
        }
      }
      await this.$apollo.mutate({
        mutation: query,
        variables: variables
      }).then(async (res) => {
        // console.log("res.data.",res.data)
        if (res.data.delete_clubs_member.affected_rows > 0) {
          this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Delete data success', life: 3000 })
          this.componentKey++
          // await this.sleep(1000);
          // window.location.reload()
        } else this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Delete data failed', life: 3000 })
        // this.$apollo.queries.listData.refresh()
      })
    },
    
  },
  // apollo: {
  //   listData: {
  //     query() {
  //       this.modelName = this.$route.meta.model;
  //       return DataServices.getList(this.modelName);
  //     },
  //     variables () {
  //       // Use vue reactive properties here
  //       return this.whereKeyList;
  //     },
  //     update(data) {
  //       var listData = data[this.dataModel.tableName]
  //       this.title = this.dataModel.label + ' '
  //       this.dataModel.processData(listData)
  //       this.$store.commit('setLoading', false);
  //       this.componentKey += 1;
  //       return data[this.dataModel.tableName]
  //     },
  //     fetchPolicy: 'network-only',
  //     error() {
  //       this.$store.commit('setLoading', false);
  //     },
  //     skip() {
  //       return !this.modelName
  //     }
  //   }
  // }

}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.field-radiobutton:has(.p-radiobutton-checked) {
  border: 2px solid #E73725;
}
.change_member__role.p-dialog.p-component {
  width: 35vw;
}
.p-inputwrapper-focus .p-dropdown-panel {
    top: 0px !important;
    left: 0px !important;
}
</style>